export const trainersByNameWithOnlyBasicDetails = /* GraphQL */ `
    query TrainersByName(
        $name: String!
        $createdOn: ModelStringKeyConditionInput
        $sortDirection: ModelSortDirection
        $filter: ModelTrainerFilterInput
        $limit: Int
        $nextToken: String
    ) {
        trainersByName(
            name: $name
            createdOn: $createdOn
            sortDirection: $sortDirection
            filter: $filter
            limit: $limit
            nextToken: $nextToken
        ) {
            items {
                id
                name
                location
                address {
                    city
                    provState
                }
                contact {
                    personalEmail
                }
                barnId
                barnName
            }
            nextToken
        }
    }
`;
